'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = GetService;

var _get = require('./../get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

GetService.$inject = ['$q'];

function GetService($q) {
    return function (src, opts) {
        return $q.resolve((0, _get2.default)(src, opts));
    };
}


//////////////////
// WEBPACK FOOTER
// /app/~/get-js/lib/angular/GetService.js
// module id = 3340
// module chunks = 38